import React, { useState } from "react";
import { Plus } from "lucide-react";
import CaptureModal from "./CaptureModal";

const CaptureFAB = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="capture-fab"
        aria-label="Open quick capture"
        className="fixed bottom-24 md:bottom-8 right-6 z-40 flex items-center gap-3 pl-4 pr-5 py-3 bg-[#00E5FF] text-[#050508] rounded-sm shadow-[0_0_40px_-8px_rgba(0,229,255,0.7)] hover:shadow-[0_0_60px_-6px_rgba(0,229,255,0.9)] hover:bg-[#7ff2ff] transition-all duration-300"
      >
        <Plus size={16} strokeWidth={2.4} />
        <span className="op-mono text-[11px] tracking-[0.28em] font-semibold">CAPTURE</span>
      </button>
      <CaptureModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default CaptureFAB;
